import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = null;

const clearError = () => null;

const hasError = (_, { payload }) => payload.message;

export default createReducer(initialState, {
  [actionTypes.FETCH_VAULT_REQUEST]: clearError,
  [actionTypes.FETCH_VAULT_FAILURE]: hasError,
});
